module.exports = __webpack_public_path__ + "img/big.dd4c493c.svg";